module.exports = __webpack_public_path__ + "static/media/my-friend-icon.d4f34ad7.svg";